// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__NJIVv","text":"styles_text__dy2l7","isExpanded":"styles_isExpanded__UpV0C"};